import { render, staticRenderFns } from "./className.vue?vue&type=template&id=3d8b68ae&scoped=true"
import script from "./className.vue?vue&type=script&lang=js"
export * from "./className.vue?vue&type=script&lang=js"
import style0 from "./className.vue?vue&type=style&index=0&id=3d8b68ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b68ae",
  null
  
)

export default component.exports